import { render, staticRenderFns } from "./ResearchGalleryPage.vue?vue&type=template&id=c90bb7d0&scoped=true"
import script from "./ResearchGalleryPage.vue?vue&type=script&lang=js"
export * from "./ResearchGalleryPage.vue?vue&type=script&lang=js"
import style0 from "./ResearchGalleryPage.vue?vue&type=style&index=0&id=c90bb7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90bb7d0",
  null
  
)

export default component.exports